export default __webpack_public_path__ + "static/media/f4.beeab918.svg";